import { Action } from 'redux';
import { ProductGroupViewModel, ProductChannelViewModel, PriceAdjustmentViewModel } from '@models/Product';
import { OptionsViewModel } from '@models/common.models';
import { CoverageOption } from '@models/CoverageOption';
import { ProductViewModel } from '@models/Product';
import { ContractActionType } from '../../../contract.actions';
import { CoverageState } from '../coverage.reducer';

/* COVERAGE GROUP */

export interface SelectCoverageProductGroupAction extends Action {
  readonly type: CoverageActionType.SelectCoverageProductGroup;
  readonly productGroup: ProductGroupViewModel;
}

export interface SetProductGroupOptionsAction extends Action {
  readonly type: CoverageActionType.SetProductGroupOptions;
  readonly productGroups: Array<ProductGroupViewModel>;
}

/* PRODUCT CHANNEL */

export interface ResetProductChannelSelectionAction extends Action {
  readonly type: CoverageActionType.ResetProductChannelSelection;
}

export interface SetProductChannelOptionsAction extends Action {
  readonly type: CoverageActionType.SetProductChannelOptions;
  readonly channels: Array<ProductChannelViewModel>;
}

export interface SelectProductChannelAction extends Action {
  readonly type: CoverageActionType.SelectProductChannel;
  readonly channel: ProductChannelViewModel;
}

/* Products */
export interface ResetProductSelectionAction extends Action {
  readonly type: CoverageActionType.ResetProductSelection;
}

export interface SetProductOptionsAction extends Action {
  readonly type: CoverageActionType.SetProductOptions;
  readonly products: Array<OptionsViewModel>;
}

export interface SelectProductAction extends Action {
  readonly type: CoverageActionType.SelectProduct;
  readonly product: ProductViewModel;
}

/* Coverage Options */
export interface SetAvailableCoverageOptionsAction extends Action {
  readonly type: CoverageActionType.SetAvailableCoverageOptions;
  readonly coverageOptions: Array<CoverageOption>;
}

export interface ToggleCoverageItemAction extends Action {
  readonly type: CoverageActionType.ToggleCoverageOption;
  readonly option: CoverageOption;
}

export interface UpdateCoverageItemAction extends Action {
  readonly type: CoverageActionType.UpdateCoverageOption;
  readonly option: CoverageOption;
}

export interface ClearCoverageSelectionsAction extends Action {
  readonly type: CoverageActionType.ClearCoverageSelections;
}

export interface SelectAllCoverageOptionsAction extends Action {
  readonly type: CoverageActionType.SelectAllCoverageOptions;
  readonly optionsToSelect: Array<CoverageOption>;
}

export interface SetDefaultCoverageOptionAction extends Action {
  readonly type: CoverageActionType.SetDefaultCoverageOption;
  readonly defaultOption: CoverageOption;
}

/* Price Adjustments */

export interface SetPriceAdjustmentOptionsAction extends Action {
  readonly type: CoverageActionType.SetPriceAdjustmentOptions;
  readonly priceAdjustments: Array<PriceAdjustmentViewModel>;
}

export interface SetPriceAdjustmentSelectionAction extends Action {
  readonly type: CoverageActionType.SetPriceAdjustmentSelection;
  readonly selection?: PriceAdjustmentViewModel;
}

export interface SetPriceAdjustmentAmountAction extends Action {
  readonly type: CoverageActionType.SetPriceAdjustmentAmount;
  readonly amount: number;
}

/* Renewal Change Fee */

export interface SetRenewalChangeFeeAction extends Action {
  readonly renewalChangeFee: number;
}

/* Sellers Coverage */
export interface SetSellersCoverageAction extends Action {
  readonly type: CoverageActionType.SetSellersCoverage;
  readonly value: boolean;
}

/* Other */

export interface SaveCoverageAction extends Action {
  readonly type: ContractActionType.SaveCoverageStep;
  readonly value: CoverageState;
}

export interface SetCoverageStateAction extends Action {
  readonly type: CoverageActionType.LoadCoverageState;
  readonly state: CoverageState;
  readonly force?: boolean;
}

export interface SetPriceAdjustmentNotesAction extends Action {
  readonly type: CoverageActionType.SetPriceAdjustmentNotes;
  readonly notes: string;
}

/* Employee Discounts */

export interface SetEmployeeDiscountOptionsAction extends Action {
  readonly type: CoverageActionType.SetEmployeeDiscountOptions;
  readonly employeeDiscounts: Array<PriceAdjustmentViewModel>;
  readonly priceAdjustmentId?: number;
}

export interface SelectEmployeeDiscountAction extends Action {
  readonly type: CoverageActionType.SelectEmployeeDiscount;
  readonly selectedEmployeeDiscount?: PriceAdjustmentViewModel;
}

export interface SetEmployeeDiscountEnabledAction extends Action {
  // ??
  readonly type: CoverageActionType.ViewEmployeeDiscount;
  readonly enabled: boolean;
}

export interface SetCoverageTotalPriceAction extends Action {
  readonly type: CoverageActionType.SetCoverageTotalPrice;
  readonly totalPrice: number;
  readonly sellersTotalPrice: number;
  readonly buyersTotalPrice: number;
  readonly totalAdjustment: number;
}

export enum CoverageActionType {
  /* Product Group */
  SelectCoverageProductGroup = 'SelectCoverageProductGroup',

  SetProductGroupOptions = 'SetProductGroupOptions',

  /* Product Channel */

  ResetProductChannelSelection = 'ResetProductChannelSelection',

  SelectProductChannel = 'SelectProductChannel',

  SetProductChannelOptions = 'SetProductChannelOptions',

  /* Products */
  SetProductOptions = 'SetProductOptions',

  ResetProductSelection = 'ResetProductSelection',
  SelectProduct = 'CoverageSelectProduct',

  /* Coverage Options */
  SetAvailableCoverageOptions = 'SetAvailableCoverageOptions',

  ToggleCoverageOption = 'ToggleCoverageOption',
  UpdateCoverageOption = 'UpdateCoverageOption',
  ClearCoverageSelections = 'ClearCoverageSelections',
  SelectAllCoverageOptions = 'SelectAllCoverageOptions',
  SetDefaultCoverageOption = 'SetDefaultCoverageOption',

  /* Price Adjustments */
  SetPriceAdjustmentOptions = 'SetPriceAdjustmentOptions',

  SetPriceAdjustmentSelection = 'SetPriceAdjustmentSelection',
  SetPriceAdjustmentAmount = 'SetPriceAdjustmentAmount',
  SetPriceAdjustmentNotes = 'SetPriceAdjustmentNotes',

  /* Renewal Change Fee */
  SetRenewalChangeFee = 'SetRenewalChangeFee',

  /* Employee Discounts */
  SetEmployeeDiscountOptions = 'SetEmployeeDiscountOptions',

  SelectEmployeeDiscount = 'EmployeeDiscountSelect',
  ViewEmployeeDiscount = 'EmployeeDiscountView',

  /* Sellers Coverage */
  SetSellersCoverage = 'SetSellersCoverage',

  /* Other */
  SetCoverageTotalPrice = 'SetCoverageTotalPrice',
  LoadCoverageState = 'LoadCoverageState'
}



// WEBPACK FOOTER //
// ./src/contract/_components/coverage/_actions/coverage.actions.types.ts